<app-product-details-container
  [offers]="offers$ | async"
  [selected]="selected$ | async"
  [offerReference]="offerReference$ | async"
  [comparisonsSelected]="comparisons$ | async"
></app-product-details-container>
